var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 36,
    viewBox: "0 0 32 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 10H26.38C25.48 8.4 24.24 7 22.74 6L26 2.82L23.18 0L18.84 4.34C17.92 4.12 17 4 16 4C15 4 14.1 4.12 13.18 4.34L8.82 0L6 2.82L9.24 6C7.74 7 6.52 8.42 5.62 10H0V14H4.18C4.06 14.66 4 15.32 4 16V18H0V22H4V24C4 24.68 4.06 25.34 4.18 26H0V30H5.62C8.94 35.74 16.28 37.68 22 34.36C23.82 33.32 25.34 31.8 26.38 30H32V26H27.82C27.94 25.34 28 24.68 28 24V22H32V18H28V16C28 15.32 27.94 14.66 27.82 14H32V10ZM24 24C24 26.1217 23.1571 28.1566 21.6569 29.6569C20.1566 31.1571 18.1217 32 16 32C13.8783 32 11.8434 31.1571 10.3431 29.6569C8.84285 28.1566 8 26.1217 8 24V16C8 13.8783 8.84285 11.8434 10.3431 10.3431C11.8434 8.84285 13.8783 8 16 8C18.1217 8 20.1566 8.84285 21.6569 10.3431C23.1571 11.8434 24 13.8783 24 16V24ZM20 14V18H12V14H20ZM12 22H20V26H12V22Z",
    fill: "#5D5D5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsect);
export default __webpack_public_path__ + "static/media/insect.659cc96f2ee6bead488df243dcdb8fbc.svg";
export { ForwardRef as ReactComponent };